import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

const theme = {
  primary: '#45a048',
  secondary: '#2863af',
  accent: '#2863af',
  info: '#00CAE3',
  cancelado: '#EF9A9A',
  liberado: '#FAFAFA',
  separado: '#B9F6CA',
  confirmar: '#F4FF81',
  venda: '#9CCC65',
}

// lime lighten-5

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
